// extracted by mini-css-extract-plugin
export default {"dotsContainer":"Spinner_dotsContainer__2aXL-","dot":"Spinner_dot__osR+I","pulse":"Spinner_pulse__Iw2+3"};